module.exports = __webpack_public_path__ + "static/media/potato-curry.51f26f40.jpg";